<template>
  <v-card
    height="100%"
    class="flex d-flex flex-column"
    style="border-width: 0"
  >
    <v-card-title
      class="primary white--text py-2"
    >
      {{ $t('detail.company_info') }}
    </v-card-title>
    <v-card-text>
      <v-row class="ma-0">
        <v-col cols="6">
          ID:
        </v-col>
        <v-col cols="6">
          <v-skeleton-loader
            v-if="loading"
            width="50%"
            type="text"
          />
          <div
            v-else
            class="primary--text"
          >
            {{ company.id }}
          </div>
        </v-col>
        <v-col cols="6">
          {{ $t('detail.company_name') }}:
        </v-col>
        <v-col cols="6">
          <v-skeleton-loader
            v-if="loading"
            width="50%"
            type="text"
          />
          <div
            v-else
            class="primary--text"
          >
            {{ company.name }}
          </div>
        </v-col>
        <v-divider />
        <v-col cols="6">
          {{ $t('detail.available_corporate') }}:
        </v-col>
        <v-col cols="6">
          <v-skeleton-loader
            v-if="loading"
            width="50%"
            type="text"
          />
          <div
            v-else
            class="primary--text"
          >
            {{ company.max - company.active }} / {{ company.max }} {{ $i18n.locale === 'jp' ? '名' : '' }}
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    company: {
      required: true,
      type: Object
    },
    loading: {
      required: true,
      type: Boolean
    }
  }
}
</script>

<style scoped>

</style>
